import { TRADABLES_TYPE } from "@helpers/constants";
import { Etc as OldEtc } from "@models/derivative/currencies/etc";
import { Tradable, TradableAdapter } from "../tradable";

export interface Etc extends Tradable {
	isin: string;
}

export class EtcAdapter extends TradableAdapter {
	public adapt(etc: OldEtc): Etc {
		const tradable = super.adapt(etc);
		return {
			...tradable,
			isin: etc.getIsin(),
			type: TRADABLES_TYPE.ETC
		};
	}
}
